/*
 * @Description: 线索管理公共枚举数据字典
 * @Author: mdb
 * @Date: 2022-07-06 14:31:16
 * @LastEditTime: 2023-03-10 10:29:09
 * @LastEditors: cxh
 */

// 线索状态
export const clueStatusEnum = [
  { value: undefined, label: '全部', lang: 'enum.all' },
  { value: 3, label: '跟进中', color: '#EF8D3C', lang: 'enum.customerStaus3' },
  { value: 8, label: '已转化', color: '#3FAC46', lang: 'enum.customerStaus8' }
]

// 线索类型
export const clueTypeEnum = [
  { value: 0, label: '新线索', lang: 'enum.clueType0' },
  { value: 1, label: '未来线索', lang: 'enum.clueType1' },
  { value: 2, label: '有效线索', lang: 'enum.clueType2' },
  { value: 3, label: '无效线索', lang: 'enum.clueType3' }
]
export default { clueStatusEnum, clueTypeEnum }
